import styled from "styled-components";
import { Radio } from "@mui/material";

export const StyledRadio = styled(Radio)`
    && {
        &.Mui-checked{
            color: var(--clr-secondary);
        }
    }
`